import { render, staticRenderFns } from "./DetalleSancionRead.vue?vue&type=template&id=27c5d7d6&"
import script from "./DetalleSancionRead.vue?vue&type=script&lang=js&"
export * from "./DetalleSancionRead.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSancionRead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports